import * as React from 'react';
import { ModalWindow } from '../../../../modal';
import { SingleSelectItem } from '../../../internal';
import styles from './styles.module.css';
import { jsx as _jsx } from "react/jsx-runtime";
export function SelectMobileModal(props) {
  var open = props.open,
    onClose = props.onClose,
    options = props.options,
    onChange = props.onChange,
    value = props.value,
    title = props.title;
  var handleChange = function handleChange(v) {
    if (onChange) {
      onChange(v);
    }
    onClose();
  };
  return /*#__PURE__*/_jsx(ModalWindow, {
    fixed: true,
    open: open,
    onClose: onClose,
    title: title,
    width: 648,
    children: /*#__PURE__*/_jsx("div", {
      className: styles['items'],
      role: "listbox",
      children: options.map(function (option) {
        var selected = value === option.value;
        return /*#__PURE__*/_jsx("div", {
          className: styles['item'],
          children: /*#__PURE__*/_jsx(SingleSelectItem, {
            option: option,
            selected: selected,
            onClick: function onClick() {
              handleChange(option.value);
            },
            role: "option",
            "aria-selected": selected ? 'true' : undefined
          })
        }, String(option.value));
      })
    })
  });
}